import React, { useState, useEffect } from "react";
import "./Banner.css";
import ViewsChart from "../LineChart/ViewsChart";
import PlatformStats from "./PlatformStats";
import { FaYoutube, FaTiktok, FaInstagram, FaChartLine, FaUsers, FaGlobe } from "react-icons/fa";
import { motion } from "framer-motion";

const Banner = () => {
  const [text, setText] = useState("455,000,000 VIEWS IN THE LAST 30 DAYS!");
  const [isFlipping, setIsFlipping] = useState(false);
  const [activeMetric, setActiveMetric] = useState('views');

  const metrics = [
    { id: 'views', icon: <FaChartLine />, value: '455M', label: 'Total Views' },
    { id: 'followers', icon: <FaUsers />, value: '+2.1M', label: 'New Followers' },
    { id: 'reach', icon: <FaGlobe />, value: '1.2B', label: 'Total Reach' }
  ];

  useEffect(() => {
    const textInterval = setInterval(() => {
      setIsFlipping(true);
      setTimeout(() => {
        setText((prevText) =>
          prevText === "GOING VIRAL IS NOT THAT HARD!"
            ? "455,000,000 VIEWS IN THE LAST 30 DAYS!"
            : "GOING VIRAL IS NOT THAT HARD!"
        );
        setIsFlipping(false);
      }, 750);
    }, 4000);

    const metricInterval = setInterval(() => {
      setActiveMetric(prev => {
        const currentIndex = metrics.findIndex(m => m.id === prev);
        return metrics[(currentIndex + 1) % metrics.length].id;
      });
    }, 5000);

    return () => {
      clearInterval(textInterval);
      clearInterval(metricInterval);
    };
  }, []);

  return (
    <div className="banner-container">
      <div className="particles-background"></div>
      
      <div className="banner-content">
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="header-section"
        >
          <h1 className="banner-title">
            <span className="gradient-text">EXISTENCE</span> MEDIA
          </h1>
          <motion.div 
          className="flip-container"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <h2 className="banner-subtitle">
            <span className={`flip-text ${isFlipping ? "flipping" : ""}`}>
              {text}
            </span>
          </h2>
        </motion.div>
          
        </motion.div>

        <div className="metrics-display">
          {metrics.map(metric => (
            <motion.div
              key={metric.id}
              className={`metric-card ${activeMetric === metric.id ? 'active' : ''}`}
              initial={{ opacity: 0 }}
              animate={{ 
                opacity: activeMetric === metric.id ? 1 : 0.6,
                scale: activeMetric === metric.id ? 1.05 : 1
              }}
              transition={{ duration: 0.5 }}
            >
              <div className="metric-icon">{metric.icon}</div>
              <div className="metric-value">{metric.value}</div>
              <div className="metric-label">{metric.label}</div>
            </motion.div>
          ))}
        </div>

        

        {/* <PlatformStats /> */}

         <div className="chart-container">  
          <ViewsChart />
           <div className="chart-annotations"> 
          
          </div> 
         </div> 

      
      </div>
    </div>
  );
};

export default Banner;